// src/components/Alert.js
import { ExclamationTriangleIcon, CheckCircleIcon, InformationCircleIcon, XCircleIcon } from '@heroicons/react/24/solid';
import GlassyIcon from './GlassyIcon';

const Alert = ({ message, type, text }) => {
  const displayText = text || message;
  if (!displayText) return null;

  let Icon;
  let containerClasses;
  let iconColor;

  switch (type) {
    case 'error':
    case 'danger':
      Icon = XCircleIcon;
      containerClasses = 'bg-gradient-to-br from-red-100/60 to-red-50/40 dark:from-red-900/40 dark:to-red-800/20';
      iconColor = 'red';
      break;
    case 'warning':
      Icon = ExclamationTriangleIcon;
      containerClasses = 'bg-gradient-to-br from-amber-100/60 to-amber-50/40 dark:from-amber-900/40 dark:to-amber-800/20';
      iconColor = 'amber';
      break;
    case 'info':
      Icon = InformationCircleIcon;
      containerClasses = 'bg-gradient-to-br from-blue-100/60 to-blue-50/40 dark:from-blue-900/40 dark:to-blue-800/20';
      iconColor = 'blue';
      break;
    default: // 'success' and any other case
      Icon = CheckCircleIcon;
      containerClasses = 'bg-gradient-to-br from-green-100/60 to-green-50/40 dark:from-green-900/40 dark:to-green-800/20';
      iconColor = 'green';
      break;
  }

  return (
    <div className={`relative backdrop-blur-sm border border-white/20 rounded-xl p-4 ${containerClasses}`}>
      <div className="flex relative z-10">
        <div className="flex-shrink-0">
          <GlassyIcon icon={Icon} size="sm" color={iconColor} />
        </div>
        <div className="ml-3 flex items-center">
          <p className="text-sm font-medium text-gray-900 dark:text-white drop-shadow-sm">{displayText}</p>
        </div>
      </div>
    </div>
  );
};

export default Alert;
